module.exports = __webpack_public_path__ + "static/media/cropping_05.4e49ff66.png";